import OliverText from "@builder/components/general/OliverText";
import "./style.scss";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface ToggleProps {
    label?: string;
    checked: boolean;
    disabled?: boolean;
    callback: (checked: boolean) => void;
    className?: string;
}

const Toggle = ({ label, checked, disabled, callback, className }: ToggleProps) => {
    const { t } = useTranslation();
    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        callback(e.currentTarget.checked);
    };

    const wrapperClass = classNames("toggle-wrapper", {
        ["disabled"]: disabled,
        [`${className}`]: className
    });

    return (
        <label className={wrapperClass}>
            {label && (
                <OliverText text={t("generalComponents.toggle." + label)} size="xs" color={disabled ? "disabled" : undefined} />
            )}
            <input type="checkbox" checked={checked} onChange={handleChange} disabled={disabled} />
            <div className="custom-toggle-input">
                <div className="toggle-handle"></div>
            </div>
        </label>
    );
};

export default Toggle;
